/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import BrandIcon from './IconFooter';
import Button from '../elements/Button';
import { useLanguage } from '../contexts/LanguageContext.js';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <div
      className="border-t border-gray-200 pb-6"
      style={{ backgroundColor: "rgba(249,250,251,0.8)" }}
    >
      <div className="container flex-col mx-auto ">
        <div className="flex flex-col sm:flex-row mt-8 justify-center">
          <div className="w-1/3 flex-col ml-16 mr-8">
            <BrandIcon />
            <p className="w-full text-lg text-green-950 font-bold mt-2">
              {t('footerDescription')}
            </p>
          </div>
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">
              {t('address')}
            </h1>
            <p className="text-tiny text-green-950 font-bold">
              Menara BRI Bandung, Lantai 11
            </p>
            <Button href="https://maps.app.goo.gl/TeJf5gKhhWkTqdxw8" type="link" target="_blank" className="flex text-tiny text-green-950 font-bold hover:underline" isExternal>
              Jl. Asia Afrika No.57, Braga, Kec. Sumur Bandung, 
              {' '}
              <br />
              Kota Bandung, Jawa Barat 40251
            </Button>
          </div>
          <div className="w-1/3 ml-16 sm:ml-0 mt-0">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">
              {t('contactInfo')}
            </h1>
            <Button href="https://mail.google.com/mail/?view=cm&fs=1&to=nabillaqadar@bulindoagroteknologi.com" type="link" target="_blank" className="flex items-center text-tiny text-green-950 font-bold hover:underline" isExternal>
              <img style={{ width: 13, height: 13, marginRight: 8 }} src="/assets/images/gmail.png" alt="Gmail" />
              nabillaqadar@bulindoagroteknologi.com
            </Button>
            <Button href="https://wa.me/+6285864699446" type="link" target="_blank" className="flex items-center text-tiny text-green-950 font-bold hover:underline" isExternal>
              <img style={{ width: 13, height: 13, marginRight: 8 }} src="/assets/images/whatsapp.png" alt="Whatsapp" />
              +62 858-6469-9446
            </Button>
            <Button href="https://wa.me/+6285864699446" type="link" target="_blank" className="flex items-center text-sm text-green-950 font-bold hover:underline" isExternal>
              <img style={{ width: 13, height: 13, marginRight: 8 }} src="/assets/images/facebook.png" alt="Facebook" />
              PT Bulindo Agro Teknologi
            </Button>
            <Button href="https://wa.me/+6285864699446" type="link" target="_blank" className="flex items-center text-sm text-green-950 font-bold hover:underline" isExternal>
              <img style={{ width: 13, height: 13, marginRight: 8 }} src="/assets/images/instagram.png" alt="Instagram" />
              BulindoAgroTeknologi
            </Button>
          </div>
        </div>
        <div className="flex-col text-center mt-7">
          <p className=" text-xs text-black font-light">
            Copyright 2026 - {t('allRightsReserved')} - Bulindo Agro Teknologi
          </p>
          </div>
        </div>
      </div>
  );
}
